import { Provider } from '@angular/core';
import { VehicleTypesApiService } from '@api';
import { VehicleTypeApiMockService } from './vehicle-type-api-mock.service';

export const VEHICLE_TYPE_PROVIDERS: Provider[] = [{ provide: VehicleTypesApiService, useClass: VehicleTypeApiMockService }];
